'use client'

import { useEffect } from 'react'
import Hotjar from '@hotjar/browser'

export const InitHotJar = () => {
  useEffect(() => {
    Hotjar.init(
      Number(process.env.NEXT_PUBLIC_HOTJAR_SITE_ID) || 0,
      Number(process.env.NEXT_PUBLIC_HOTJAR_VERSION) || 6
    )
  }, [])

  return <></>
}
